import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Terms from './pages/Terms';
import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import SixMonthTrial from './pages/SixMonthTrial';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import GooglePlayground from './pages/GooglePlayground';
import Admin from './pages/admin/Admin';
import AdminLogin from './pages/admin/AdminLogin';
import AdminProtectedRoute from './components/AdminProtectedRoute';

function App() {
  return (
    <Theme
      appearance="dark"
      accentColor="grass"
      grayColor="gray"
      panelBackground="solid"
      scaling="100%"
      radius="full"
    >
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sixmonthtrial" element={<SixMonthTrial />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacypolicy" element={<Privacy />} />
          <Route path="/playground/google" element={<GooglePlayground />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <AdminProtectedRoute>
              <Admin />
            </AdminProtectedRoute>
          } />
        </Routes>
      </Router>
    </Theme>
  );
}

export default App;
